export function timeAgo(iso, lang = "de") {
  if (!iso) return "—";
  const then = new Date(iso).getTime();
  if (isNaN(then)) return "—";
  const s = Math.floor((Date.now() - then) / 1000);
  const L = lang === "de"
    ? { now: "gerade eben", s: "s", m: "min", h: "Std", d: "T", ago: "vor " }
    : { now: "just now", s: "s", m: "min", h: "h", d: "d", ago: "" };
  const suf = lang === "de" ? "" : " ago";
  if (s < 5) return L.now;
  if (s < 60) return `${L.ago}${s}${L.s}${suf}`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${L.ago}${m}${L.m}${suf}`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${L.ago}${h}${L.h}${suf}`;
  const d = Math.floor(h / 24);
  return `${L.ago}${d}${L.d}${suf}`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleString("de-DE", { timeZone: "Europe/Berlin", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function fmtDateOnly(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return String(iso);
  return d.toLocaleDateString("de-DE", { timeZone: "Europe/Berlin", day: "2-digit", month: "2-digit", year: "numeric" });
}

// Erkennt ISO-Datum/Zeit-Strings und formatiert sie deutsch; sonst unveraendert.
const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}(?:[T ]\d{2}:\d{2}(?::\d{2})?(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})?)?$/;
export function fmtAuto(v) {
  if (v == null) return v;
  const s = String(v).trim();
  if (!ISO_DATE_RE.test(s)) return v;
  return s.length <= 10 ? fmtDateOnly(s) : fmtDate(s);
}
